import { Box, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { InventoryLotReference } from "../types"

import { Button } from "@/components/common/Button"

interface AdjustmentUntestedLotsDialogProps {
  untestedLots: InventoryLotReference[]
  onClose: () => void
}

export const InventoryUntestedLotsDialog: FC<AdjustmentUntestedLotsDialogProps> = ({ untestedLots, onClose }) => (
  <Dialog open onClose={onClose} data-testid='inventory.untested-lots-dialog'>
    <DialogContent classes={{ root: "p-10" }}>
      <Box className='mb-6 w-full justify-center text-center'>
        <WarningOutlined className='size-12 text-secondary-600' />
        <Typography
          data-testid='inventory.untested-lots-dialog.title'
          variant='h5'
          color='primary'
          className='mt-6 font-normal'
          component='h2'
        >
          Lot Numbers Not Found
        </Typography>
      </Box>
      <Box
        className='mt-6 px-3 text-center text-base leading-[150%] tracking-[-0.85px] text-gray-700'
        data-testid='inventory.untested-lots-dialog.content'
      >
        <p className='mb-4'>
          The selected Lot # / Batch # does not exist for this product. Please add the Lot # / Batch # to the product
          before continuing.
        </p>
        <ul className='list-disc px-4 text-left font-normal'>
          {untestedLots.map((lot) => {
            const key = `${lot.lotNumber}-${lot.batchNumber}-${lot.palletReferenceNumber}`

            return (
              <li key={key} data-testid={`inventory.untested-lots-dialog.lot-${key}`}>
                Lot #<b>{lot.lotNumber}</b>
                {lot.batchNumber && (
                  <>
                    , Batch #<b>{lot.batchNumber}</b>
                  </>
                )}{" "}
                {lot.palletReferenceNumber && (
                  <>
                    for Pallet Reference #<b>{lot.palletReferenceNumber}</b>
                  </>
                )}
              </li>
            )
          })}
        </ul>
      </Box>
    </DialogContent>
    <DialogActions className='justify-end px-10 pb-10 pt-0'>
      <Button data-testid='inventory.untested-lots-dialog.submit-button' variant='primary' onClick={onClose}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
)
